var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.66663 3.99996C7.19424 3.99996 6.75803 4.16171 6.45057 4.42525C6.14629 4.68606 5.99996 5.01575 5.99996 5.33329C5.99996 5.70148 5.70148 5.99996 5.33329 5.99996C4.9651 5.99996 4.66663 5.70148 4.66663 5.33329C4.66663 4.58997 5.01196 3.90224 5.58285 3.41291C6.15056 2.9263 6.90134 2.66663 7.66663 2.66663H8.33329C9.09858 2.66663 9.84936 2.9263 10.4171 3.41291C10.9831 3.89805 11.3274 4.57821 11.3332 5.31422C11.3616 5.88499 11.2058 6.44997 10.8886 6.92574C10.5754 7.39561 10.1213 7.75361 9.59205 7.94867C9.35142 8.06926 9.10952 8.30673 8.92893 8.6679C8.74276 9.04025 8.64591 9.49885 8.66602 9.97163C8.68167 10.3395 8.39615 10.6504 8.02829 10.666C7.66043 10.6817 7.34954 10.3961 7.33389 10.0283C7.30491 9.34683 7.44158 8.66118 7.73636 8.07162C8.03067 7.483 8.48088 6.99665 9.05028 6.72968C9.07047 6.72021 9.09111 6.71177 9.11214 6.70438C9.38479 6.6085 9.61891 6.42662 9.77923 6.18614C9.93955 5.94566 10.0174 5.6596 10.001 5.37104C10.0003 5.35847 9.99996 5.34588 9.99996 5.33329C9.99996 5.01575 9.85363 4.68606 9.54935 4.42525C9.24189 4.16171 8.80568 3.99996 8.33329 3.99996H7.66663ZM7.99996 12C8.36815 12 8.66663 12.2984 8.66663 12.6666V12.6733C8.66663 13.0415 8.36815 13.34 7.99996 13.34C7.63177 13.34 7.33329 13.0415 7.33329 12.6733V12.6666C7.33329 12.2984 7.63177 12 7.99996 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionIcon);
export default __webpack_public_path__ + "static/media/questionIcon.344d08136b743bf8107ef120ce9b453d.svg";
export { ForwardRef as ReactComponent };